/**
 * https://www.pdftron.com/api/web/Core.DocumentViewer.html#getTool__anchor
 */
export default toolName => window.documentViewer.getTool(toolName);
